import { generateId } from '@freelancer/datastore/testing';
import { PoolModel } from './pools.model';

export interface GeneratePoolOptions {
  readonly id?: number;
  readonly name: string;
  readonly displayName: string;
  readonly isTalentNetwork?: boolean;
  readonly isTestPool?: boolean;
  readonly dateCreated?: number;
  readonly isInsourceEnabled?: boolean;
  readonly isCurrencyEnabled?: boolean;
}

export function generatePoolObject({
  id,
  name,
  displayName,
  isTalentNetwork = false,
  isTestPool = false,
  dateCreated = Date.now(),
  isInsourceEnabled = false,
  isCurrencyEnabled = true,
}: GeneratePoolOptions): PoolModel {
  return {
    id: id ?? generateId(),
    name,
    displayName,
    isTalentNetwork,
    isTestPool,
    dateCreated,
    isInsourceEnabled,
    isCurrencyEnabled,
  };
}

export function generatePoolObjects(
  pools: readonly GeneratePoolOptions[],
): readonly PoolModel[] {
  return pools.map(generatePoolObject);
}

export function freelancerPool(): Required<GeneratePoolOptions> {
  return {
    id: 1,
    name: 'freelancer',
    displayName: 'Freelancer',
    isTalentNetwork: false,
    isTestPool: false,
    dateCreated: new Date(2021, 2, 16).getTime(),
    isInsourceEnabled: false,
    isCurrencyEnabled: true,
  };
}

export function deloittePool(): Required<GeneratePoolOptions> {
  return {
    id: 2,
    name: 'deloitte_dc',
    displayName: 'Deloitte',
    isTalentNetwork: false,
    isTestPool: false,
    dateCreated: new Date(2021, 2, 16).getTime(),
    isInsourceEnabled: true,
    isCurrencyEnabled: false,
  };
}

export function arrowPool(): Required<GeneratePoolOptions> {
  return {
    id: 3,
    name: 'arrow',
    displayName: 'Arrow',
    isTalentNetwork: false,
    isTestPool: false,
    dateCreated: new Date(2021, 2, 16).getTime(),
    isInsourceEnabled: false,
    isCurrencyEnabled: true,
  };
}

export function facebookPool(): Required<GeneratePoolOptions> {
  return {
    id: 4,
    name: 'facebook',
    displayName: 'Facebook',
    isTalentNetwork: true,
    isTestPool: false,
    dateCreated: new Date(2021, 2, 16).getTime(),
    isInsourceEnabled: false,
    isCurrencyEnabled: true,
  };
}

export function talentNetworkPool(): Required<GeneratePoolOptions> {
  return {
    id: 11,
    name: 'big_talent_marketplace',
    displayName: 'Big Talent Marketplace',
    isTalentNetwork: true,
    isTestPool: false,
    dateCreated: new Date(2021, 2, 16).getTime(),
    isInsourceEnabled: false,
    isCurrencyEnabled: true,
  };
}

export function anotherTalentNetworkPool(): Required<GeneratePoolOptions> {
  return {
    id: 12,
    name: 'spectacular_seeds',
    displayName: 'Spectacular Seeds Ltd',
    isTalentNetwork: true,
    isTestPool: false,
    dateCreated: new Date(2021, 2, 16).getTime(),
    isInsourceEnabled: false,
    isCurrencyEnabled: true,
  };
}
